import * as React from "react";
import {
    PlasmicTextarea,
    DefaultTextareaProps
} from "./plasmic/main/PlasmicTextarea";
import {useEffect, useState} from "react";

export interface TextareaProps extends DefaultTextareaProps {
    defaultValue: string,
    onFinish?: (name: string) => any,
    autoFocus?: boolean,
}

function Textarea({defaultValue, autoFocus, onFinish, ...rest}: TextareaProps) {
    const [text, setText] = useState<string>(defaultValue);

    useEffect(() => {
        setText(defaultValue);
        // The other dependencies are needed since the default value does not change by switching between newly added
        // notes.
    }, [defaultValue, autoFocus, onFinish]);

    return <PlasmicTextarea
        {...rest}
        root={{
            value: text,
            autoFocus: !!autoFocus,
            onChange: (e) => {
                setText(e.target.value);
            },
            onBlur: () => {
                onFinish && onFinish(text);
            },
            onKeyDown: (event: any) => {
                if (event.key === 'Enter') {
                    onFinish && onFinish(text);
                }
            }
        }}

    />;
}

export default Textarea;
